import type { InputConfig } from "@smartsuite/automation-engine-api";

export const isValueExist = (input: InputConfig): boolean => {
  const config = input.value?.values[0]?.value;
  if (config !== undefined) {
    switch (config.oneofKind) {
      case "fileUrl":
        return config.fileUrl !== undefined;
      case "option":
        return config.option.label !== "";
      case "number":
        return config.number !== undefined;
      case "date":
        return config.date.seconds !== "0";
      case "function":
        return config.function?.function?.oneofKind !== undefined;
      case "string":
        return config.string !== undefined && config.string !== "";
      case "smartdoc":
        return config.smartdoc !== undefined && config.smartdoc !== "";
      case "reference":
        return config.reference.outputId !== undefined;
      case "file":
        return config.file !== undefined;
      case "checklist":
        return config.checklist !== undefined;
      case "status":
        return (
          config.status.status !== undefined && config.status.status !== ""
        );
      case "tag":
        return config.tag.label !== undefined && config.tag.label !== "";
      default:
        return false;
    }
  }
  return false;
};
